module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="apexchat_question_type_multiple_choice_radio livechat_rd_fade_in_bottom_delay apexchat_qt_button_' +
((__t = (messageId )) == null ? '' : __t) +
'_' +
((__t = (id )) == null ? '' : __t) +
'" tabindex="0" id="apexchat_question_type_multiple_choice_radio_parent_option_label_' +
((__t = (messageId )) == null ? '' : __t) +
'_' +
((__t = (id )) == null ? '' : __t) +
'" style="' +
((__t = (styles )) == null ? '' : __t) +
' ">\r\n    <input type="radio" name="apexchat_question_type_radio_group_' +
((__t = (messageId)) == null ? '' : __t) +
'" id="apexchat_scripts_radio_' +
((__t = (messageId )) == null ? '' : __t) +
'_' +
((__t = (id )) == null ? '' : __t) +
'" value="' +
((__t = (name )) == null ? '' : __t) +
'"  />\r\n    <label class="apexchat_question_type_multiple_choice_radio_label" for="apexchat_scripts_radio_' +
((__t = (messageId )) == null ? '' : __t) +
'_' +
((__t = (id )) == null ? '' : __t) +
'">\r\n        <span><!-- This span is needed to create the "checkbox" element --></span>\r\n        <div class="apexchat_text apexchat_question_type_multiple_choice_radio_label_align" id="apexchat_question_type_multiple_choice_radio_option_label_' +
((__t = (messageId )) == null ? '' : __t) +
'_' +
((__t = (id )) == null ? '' : __t) +
'" style="' +
((__t = (fontStyle )) == null ? '' : __t) +
' ">\r\n            ' +
((__t = (name )) == null ? '' : __t) +
'\r\n        </div>\r\n    </label>\r\n</div>';

}
return __p
}